import React from 'react';
import { Table} from '@mantine/core';
import styles from './Table.module.css'

interface GenericTableProps {
  headers: string[];
  rows: React.ReactNode; 
}

const TableMedusa = ({ headers, rows }: GenericTableProps) =>{
    return(
    <Table.ScrollContainer  minWidth={500} maxHeight={450} type="native">
         <Table  className={styles.TableMedusa}>
      <Table.Thead>
        <Table.Tr>
          {headers.map((header, index) => (
            <Table.Th key={index}>{header}</Table.Th>
          ))}
        </Table.Tr>
      </Table.Thead>
      <Table.Tbody>{rows}</Table.Tbody>
    </Table>
    </Table.ScrollContainer>);}

export default TableMedusa


